import { render, staticRenderFns } from "./BusinessClue.vue?vue&type=template&id=8c07b970&scoped=true&"
import script from "./BusinessClue.vue?vue&type=script&lang=js&"
export * from "./BusinessClue.vue?vue&type=script&lang=js&"
import style0 from "./BusinessClue.vue?vue&type=style&index=0&id=8c07b970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c07b970",
  null
  
)

export default component.exports